import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-bold-building-4',
  standalone: true,
  imports: [],
  templateUrl: './icon-bold-building-4.component.html',
  styleUrl: './icon-bold-building-4.component.scss'
})
export class IconBoldBuilding4Component {
  @Input() color: string = '#000000';
  @Input() size: string = '24px';
}
